import { serverUrl } from '../config';
import axios from 'axios';
import { useStore } from '../hooks/useStore';
import { triggerLogout } from '../contexts/authEvent';

const blogApi = axios.create({
  baseURL: 'https://auth.iceportal.com/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getOnlineNode = (endpoint, options) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const user = useStore();

  // Create a local instance for this call
  const scopedApi = axios.create({
    baseURL: serverUrl,
    withCredentials: true,
    timeout: 3000000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add interceptor only for this instance
  scopedApi.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        triggerLogout();
      }
      return Promise.reject(error);
    }
  );

  let params = {
    method: 'get',
    url: endpoint,
    headers: {
      'Cache-Control': 'no-cache',
    },
    ...options
  }

  if (user && user.csrf_token) {
    params.headers['X-CSRF-Token'] = user.csrf_token;
  }

  return scopedApi(params);
};

export const getExternal = (endpoint, method) => {
  return blogApi({
    method: method ? method : 'get',
    url: endpoint,
    withCredentials: false,
  });
};